import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TitleDialog from "~/components/modalBookingScreen/TitleDialog";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { withRouter } from "react-router";
import { Check, FileCopyOutlined } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import _ from "lodash";

const PIX_EXPIRY_SECONDS = 40 * 60;

const DialogPayCod = (props) => {
	const { onClose, pixCode, businessId, onGiveUp, paymentValue, onViewBooking } = props;
	const { t } = useTranslation();

	const [hasCopied, setHasCopied] = useState(false);
	const [visible, setVisible] = useState(true);
	const [open, setOpen] = useState(false);
	const [secondsLeft, setSecondsLeft] = useState(PIX_EXPIRY_SECONDS);
	const [confirmedVisible, setConfirmedVisible] = useState(false);

	const { isVerifying = false, isConfirmed = false } = props;

	useEffect(() => {
		if (isConfirmed) {
			setTimeout(() => setConfirmedVisible(true), 50);
		} else {
			setConfirmedVisible(false);
		}
	}, [isConfirmed]);

	useEffect(() => {
		if (isVerifying || isConfirmed) {
			setOpen(false);
		}
	}, [isVerifying, isConfirmed]);

	const { user } = useSelector((store) => store.auth);
	const { business } = useSelector((store) => store.business);
	const meStore = useSelector((store) => store.me);

	const currentUser = meStore?.me || user || {};
	const isOwnerUser = !_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	useEffect(() => {
		const interval = setInterval(() => {
			setSecondsLeft((s) => Math.max(0, s - 1));
		}, 1000);
		return () => clearInterval(interval);
	}, []);

	const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, "0");
	const seconds = String(secondsLeft % 60).padStart(2, "0");

	const handleCopy = () => {
		if (hasCopied) return;
		if (isOwnerUser) {
			mixpanelTrackEvent("Copiar_Codigo_Pix", {}, currentUser, business);
		}
		setVisible(false);
		setTimeout(() => {
			setHasCopied(true);
			setVisible(true);
		}, 250);
	};

	return (
		<>
			<DialogTitle>
				<TitleDialog onClose={() => isConfirmed ? onViewBooking() : setOpen(true)} message={""} />
			</DialogTitle>

			{isConfirmed ? (
				<div style={{ padding: "0 24px 32px", overflow: "hidden" }}>
					<div style={{
						width: 64,
						height: 64,
						borderRadius: "50%",
						backgroundColor: "#e8f5e9",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						margin: "0 auto 24px",
						opacity: confirmedVisible ? 1 : 0,
						transform: confirmedVisible ? "translateY(0)" : "translateY(30px)",
						transition: "opacity 0.45s ease, transform 0.45s ease",
					}}>
						<Check style={{ color: "#4caf50", fontSize: 32 }} />
					</div>
					<Typography style={{
						fontSize: 18, fontWeight: 700, color: "#111c29", marginBottom: 8, textAlign: "center",
						opacity: confirmedVisible ? 1 : 0,
						transform: confirmedVisible ? "translateY(0)" : "translateY(30px)",
						transition: "opacity 0.45s ease 0.08s, transform 0.45s ease 0.08s",
					}}>
						{t("pix_dialog_confirmed_title")}
					</Typography>
					<Typography style={{
						fontSize: 14, color: "#888", marginBottom: 32, lineHeight: 1.5, textAlign: "center",
						opacity: confirmedVisible ? 1 : 0,
						transform: confirmedVisible ? "translateY(0)" : "translateY(30px)",
						transition: "opacity 0.45s ease 0.16s, transform 0.45s ease 0.16s",
					}}>
						{paymentValue ? t("pix_dialog_payment_received_value", { value: paymentValue }) : t("pix_dialog_payment_received")}
					</Typography>
					<div style={{
						opacity: confirmedVisible ? 1 : 0,
						transform: confirmedVisible ? "translateY(0)" : "translateY(30px)",
						transition: "opacity 0.45s ease 0.24s, transform 0.45s ease 0.24s",
					}}>
						<Button
							fullWidth
							onClick={onViewBooking}
							style={{
								backgroundColor: "#672E37",
								color: "#fff",
								borderRadius: 30,
								padding: "14px 0",
								fontSize: 16,
								fontWeight: 600,
								textTransform: "none",
							}}>
							{t("pix_dialog_view_booking")}
						</Button>
					</div>
				</div>
			) : (
			<div style={{
				padding: "0 24px 24px",
				minHeight: 380,
				opacity: visible ? 1 : 0,
				transform: visible ? "translateY(0)" : "translateY(6px)",
				transition: "opacity 0.25s ease, transform 0.25s ease",
				overflow: "hidden",
			}}>
				<Typography
					style={{
						fontSize: 16,
						fontWeight: 600,
						color: "#111c29",
						textAlign: "center",
						marginBottom: 24,
					}}>
					{t("pix_dialog_title")}
				</Typography>

				{/* Step 1 */}
				<div style={{ display: "flex", alignItems: "flex-start", marginBottom: 12 }}>
					{hasCopied ? (
						<div
							style={{
								width: 28,
								height: 28,
								borderRadius: "50%",
								backgroundColor: "#e8f5e9",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								flexShrink: 0,
								marginRight: 12,
							}}>
							<Check style={{ color: "#4caf50", fontSize: 16 }} />
						</div>
					) : (
						<div
							style={{
								width: 28,
								height: 28,
								borderRadius: "50%",
								backgroundColor: "#672E37",
								color: "#fff",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: 14,
								fontWeight: 700,
								flexShrink: 0,
								marginRight: 12,
							}}>
							1
						</div>
					)}
					<Typography
						style={{
							fontSize: 15,
							fontWeight: hasCopied ? 400 : 600,
							color: hasCopied ? "#aaa" : "#111c29",
							lineHeight: "28px",
						}}>
						{hasCopied ? t("pix_dialog_code_copied") : t("pix_dialog_copy_code_below")}
					</Typography>
				</div>

				{/* Step 2 */}
				<div style={{ display: "flex", alignItems: "flex-start", marginBottom: 20 }}>
					<div
						style={{
							width: 28,
							height: 28,
							borderRadius: "50%",
							backgroundColor: hasCopied ? "#672E37" : "#efefef",
							color: hasCopied ? "#fff" : "#aaa",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: 14,
							fontWeight: 600,
							flexShrink: 0,
							marginRight: 12,
						}}>
						2
					</div>
					<Typography
						style={{
							fontSize: 14,
							fontWeight: hasCopied ? 600 : 400,
							color: hasCopied ? "#111c29" : "#aaa",
							lineHeight: 1.4,
							paddingTop: 4,
						}}>
						{t("pix_dialog_pay_instructions")}
					</Typography>
				</div>

				{/* Code box */}
				<div
					style={{
						border: "1.5px solid #ddd",
						borderRadius: 8,
						display: "flex",
						alignItems: "center",
						padding: "10px 14px",
						marginBottom: 20,
					}}>
					<Typography
						style={{
							flex: 1,
							fontSize: 14,
							color: "#333",
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap",
							userSelect: "none",
						}}>
						{pixCode?.substring(0, 20)}
					</Typography>
					<CopyToClipboard text={pixCode} onCopy={handleCopy}>
						<FileCopyOutlined style={{ color: hasCopied ? "#3689ea" : "#555", cursor: "pointer", marginLeft: 8 }} />
					</CopyToClipboard>
				</div>

				{/* Timer / Aguardando pagamento */}
				{hasCopied ? (
					<div
						style={{
							backgroundColor: "#fefce8",
							border: "1.5px solid #fde68a",
							borderRadius: 30,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							padding: "12px 20px",
							marginBottom: 20,
							gap: 8,
						}}>
						{isVerifying ? (
							<CircularProgress size={14} thickness={5} style={{ color: "#f59e0b", flexShrink: 0 }} />
						) : (
							<div
								style={{
									width: 9,
									height: 9,
									borderRadius: "50%",
									backgroundColor: "#f59e0b",
									flexShrink: 0,
								}}
							/>
						)}
						<Typography style={{ fontSize: 14, fontWeight: 500, color: "#78350f" }}>
							{isVerifying ? t("pix_dialog_verifying") : t("pix_dialog_waiting", { time: `${minutes}:${seconds}` })}
						</Typography>
					</div>
				) : (
					<Typography
						style={{
							fontSize: 14,
							color: "#555",
							textAlign: "center",
							marginBottom: 24,
							lineHeight: 1.5,
						}}>
						{t("pix_dialog_timer_prefix")}{" "}
						<span style={{ fontWeight: 700, color: "#111" }}>
							{minutes}:{seconds}
						</span>{" "}
						{t("pix_dialog_timer_suffix")}
					</Typography>
				)}

				{/* Button */}
				{hasCopied ? (
					<CopyToClipboard text={pixCode} onCopy={handleCopy}>
						<Button
							fullWidth
							style={{
								color: "#672E37",
								fontSize: 15,
								fontWeight: 600,
								textTransform: "none",
								background: "none",
							}}>
							{t("pix_dialog_copy_again")}
						</Button>
					</CopyToClipboard>
				) : (
					<CopyToClipboard text={pixCode} onCopy={handleCopy}>
						<Button
							fullWidth
							style={{
								backgroundColor: "#672E37",
								color: "#fff",
								borderRadius: 30,
								padding: "14px 0",
								fontSize: 16,
								fontWeight: 600,
								textTransform: "none",
							}}>
							{t("pix_dialog_copy_code")}
						</Button>
					</CopyToClipboard>
				)}
			</div>
			)}

			{/* Give up / verifying confirmation dialog */}
			<Dialog
				onClose={() => setOpen(false)}
				open={open}
				PaperProps={{
					style: { borderRadius: 24, maxWidth: "320px", padding: "8px 0" },
				}}>
				<DialogContent style={{ padding: "24px 24px 16px" }}>
					{isVerifying ? (
						<>
							<Typography style={{ fontSize: 17, fontWeight: 700, color: "#111c29", textAlign: "center", marginBottom: 12 }}>
								{t("pix_dialog_processing_title")}
							</Typography>
							<Typography style={{ fontSize: 14, color: "#666", textAlign: "center", lineHeight: 1.5 }}>
								{t("pix_dialog_processing_body")}
							</Typography>
						</>
					) : (
						<>
							<Typography style={{ fontSize: 17, fontWeight: 700, color: "#111c29", textAlign: "center", marginBottom: 12 }}>
								{t("pix_dialog_cancel_title")}
							</Typography>
							<Typography style={{ fontSize: 14, color: "#666", textAlign: "center", lineHeight: 1.5 }}>
								{t("pix_dialog_cancel_body")}{" "}
								<span style={{ fontWeight: 700, color: "#111c29" }}>{minutes}:{seconds}</span>.
							</Typography>
						</>
					)}
				</DialogContent>
				<DialogActions style={{ justifyContent: "center", gap: 12, padding: "8px 24px 24px" }}>
					{!isVerifying && (
						<Button
							onClick={() => {
								if (onGiveUp) onGiveUp();
								onClose();
								props.history.push(`/business/${businessId}`);
							}}
							style={{
								flex: 1,
								border: "2px solid #672E37",
								color: "#672E37",
								borderRadius: 30,
								padding: "10px 0",
								fontSize: 15,
								fontWeight: 600,
								textTransform: "none",
							}}>
							{t("pix_dialog_cancel")}
						</Button>
					)}
					<Button
						onClick={() => setOpen(false)}
						style={{
							flex: isVerifying ? undefined : 1,
							backgroundColor: "#672E37",
							color: "#fff",
							borderRadius: 30,
							padding: "10px 0",
							fontSize: 15,
							fontWeight: 600,
							textTransform: "none",
							...(isVerifying && { width: "100%" }),
						}}>
						{isVerifying ? t("pix_dialog_wait_ok") : t("pix_dialog_wait")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default withRouter(DialogPayCod);
